import { Link } from "react-router-dom";
import { COMPANY } from "../data/company";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Siden blev ikke fundet (404)"
        description={`Siden blev ikke fundet hos ${COMPANY.name}. Gå til forsiden eller kontakt os.`}
        path="/404"
      />

      <section className="py-24 sm:py-32 bg-[#FAFAF8] min-h-[60vh] flex items-center">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-20 h-20 rounded-full bg-[#111111] text-[#A78E51] border border-[#A78E51]/40 flex items-center justify-center mx-auto mb-6 text-3xl font-extrabold shadow-sm">
            404
          </div>

          <span className="text-[#A78E51] font-bold text-xs uppercase tracking-widest block mb-2">
            Fejl 404
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-[#111111] tracking-tight">
            Beklager, siden blev ikke fundet
          </h1>
          <p className="mt-4 text-neutral-600 text-sm sm:text-base max-w-lg mx-auto leading-relaxed">
            Siden du leder efter, findes desværre ikke eller er blevet flyttet. Brug knapperne herunder til at navigere tilbage til forsiden eller kontakte os.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-[#111111] text-white font-bold text-sm hover:bg-neutral-800 transition-colors shadow-sm"
            >
              <i className="fa-solid fa-house text-[#A78E51] text-xs" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md bg-white border border-neutral-300 text-[#111111] hover:border-[#A78E51] font-bold text-sm transition-colors shadow-sm"
            >
              <i className="fa-solid fa-envelope text-[#A78E51] text-xs" aria-hidden="true" />
              <span>Kontakt os</span>
            </Link>
          </div>

          <div className="mt-12 pt-8 border-t border-neutral-200 text-xs text-neutral-500">
            <span>Har du brug for akut hjælp? Ring direkte til Andreas på </span>
            <a href={COMPANY.phoneLink} className="text-[#111111] font-bold hover:text-[#A78E51] underline">
              {COMPANY.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
